module.exports = "<section class=\"slide-select-wrapper animated\"> <div class=slide-mask-layer></div> <div class=slide-item-container> <% for (var key in data.data) { %> <div class=slide-item-group> <% for (var i = 0; i < data.data[key].length; i++) { %> <div class=slide-item data-code=\"<%= data.data[key][i].code %>\"><%= data.data[key][i].name %><i class=\"slide-active-logo iconfont\">√</i></div> <% } %> </div> <% } %> </div> </section>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/sellcar/modules/select_city/select_city_tpl.html
// module id = 92
// module chunks = 2 3 4 5